import { ReportYears } from 'src/store/baseUrl/baseUrlStore.types';
import { API_BASE_URL } from 'src/services/envVariableLoader';
import { Language } from 'src/store/language/languageStore.types';
import { ProjectDataStoreType } from 'src/store/projectData/projectDataStore.types';

export const getRandomProjectData: (
  language: Language,
  isMobileView: boolean,
  reportYears: ReportYears
) => Promise<ProjectDataStoreType['randomProjects']> = async (
  language,
  isMobileView,
  reportYears
) => {
  const query = reportYears
    ? '?' +
      Object.entries(reportYears)
        .map(([key, value]: [key: string, value: string | number]) => {
          if (key === 'typeOfProjectPartner')
            return encodeURIComponent('type') + '=' + encodeURIComponent(value);
          return encodeURIComponent(key) + '=' + encodeURIComponent(value);
        })
        .join('&')
    : '';
  const response = await fetch(
    `${API_BASE_URL}/projects/${language}/${
      isMobileView ? 'lowRes' : 'highRes'
    }/randomProjects${query}`
  );
  const data: ProjectDataStoreType['randomProjects'] = await response.json();
  return data;
};
